<template>
  <div class="iq-side-panel-user-message" data-testid="iq-side-panel-user-message">
    <div class="iq-side-panel-user-message__bubble">
      <div
        v-if="attachmentRefs.length"
        class="iq-side-panel-user-message__attachments"
        data-testid="iq-side-panel-user-message-attachments"
      >
        <AskAQuestionAttachmentCard
          v-for="(attachment, index) in attachmentRefs"
          :key="attachment.id || `${attachment.name}-${index}`"
          :attachment="attachment"
          :index="index"
          readonly
          @preview-image="openImagePreview"
        />
      </div>
      <p v-if="message" class="iq-side-panel-user-message__text">
        <span
          v-for="segment in segments"
          :key="segment.start"
          :class="{ 'iq-side-panel-user-message__mention': segment.mention }"
          :data-employee-id="segment.mention ? segment.mention.employee_id : null"
          >{{ segment.text }}</span
        >
      </p>
    </div>
    <AskAQuestionAttachmentImagePreview
      :open="Boolean(imagePreview)"
      :image-src="imagePreview?.src || ''"
      :image-name="imagePreview?.name || 'Image preview'"
      @close="closeImagePreview"
    />
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import { segmentTextWithMentions } from "@components/AskAQuestionPrompt/mentionTokens";
import AskAQuestionAttachmentCard from "@components/AskAQuestionPrompt/AskAQuestionAttachmentCard.vue";
import AskAQuestionAttachmentImagePreview from "@components/AskAQuestionPrompt/AskAQuestionAttachmentImagePreview.vue";

const props = defineProps({
  message: {
    type: String,
    default: "",
  },
  attachmentRefs: {
    type: Array,
    default: () => [],
  },
  mentions: {
    type: Array,
    default: () => [],
  },
});

const segments = computed(() => segmentTextWithMentions(props.message, props.mentions));

const imagePreview = ref(null);

const openImagePreview = (payload) => {
  if (!payload?.src) {
    return;
  }
  imagePreview.value = payload;
};

const closeImagePreview = () => {
  imagePreview.value = null;
};
</script>

<style scoped>
.iq-side-panel-user-message {
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  width: 100%;
  background: #ffffff;
}

.iq-side-panel-user-message__bubble {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 228px;
  padding: 12px 16px;
  background: #f3f4f6;
  border-radius: 20px;
  box-sizing: border-box;
}

.iq-side-panel-user-message__attachments {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  margin-bottom: 8px;
}

.iq-side-panel-user-message__attachments:last-child {
  margin-bottom: 0;
}

.iq-side-panel-user-message__mention {
  font-weight: 600;
  color: #4f46e5;
}

.iq-side-panel-user-message__text {
  margin: 0;
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 15px;
  line-height: 22px;
  color: #111727;
  word-break: break-word;
  white-space: pre-wrap;
}
</style>
